/*
 * Sets up default collections of models used throughout the site.
 *
 * @author Jonathon McDonald <jonathon@agencyfusion.com>
 * @author Rachel Wolthuis <rachel@agencyfusion.com>
 */
(function () {
  var Products = Backbone.Collection.extend({
    model: window.App.Models.Product
  });

  window.App.Collections.Products = Products;
})();